/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SiteNonDetect } from './SiteNonDetect';
import {
    SiteNonDetectFromJSON,
    SiteNonDetectFromJSONTyped,
    SiteNonDetectToJSON,
    SiteNonDetectToJSONTyped,
} from './SiteNonDetect';

/**
 * 
 * @export
 * @interface PaginatedSiteNonDetectList
 */
export interface PaginatedSiteNonDetectList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedSiteNonDetectList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSiteNonDetectList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSiteNonDetectList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<SiteNonDetect>}
     * @memberof PaginatedSiteNonDetectList
     */
    results: Array<SiteNonDetect>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedSiteNonDetectList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedSiteNonDetectList interface.
 */
export function instanceOfPaginatedSiteNonDetectList(value: object): value is PaginatedSiteNonDetectList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedSiteNonDetectListFromJSON(json: any): PaginatedSiteNonDetectList {
    return PaginatedSiteNonDetectListFromJSONTyped(json, false);
}

export function PaginatedSiteNonDetectListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedSiteNonDetectList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(SiteNonDetectFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedSiteNonDetectListToJSON(json: any): PaginatedSiteNonDetectList {
    return PaginatedSiteNonDetectListToJSONTyped(json, false);
}

export function PaginatedSiteNonDetectListToJSONTyped(value?: PaginatedSiteNonDetectList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(SiteNonDetectToJSON)),
        'num_pages': value['numPages'],
    };
}

